module.exports = __webpack_public_path__ + "static/media/sample_Triangel.aaff221d.mp3";